const cachedImagePromises = new Map<string, Promise<string | null>>();

const PDF_BACKGROUND_URL = '/pdf/pdf_background.png';
const PREFEITURA_LOGO_URL = '/prefeitura.png';

const blobToDataUrl = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }
      reject(new Error('Falha ao converter a imagem do PDF.'));
    };
    reader.onerror = () => reject(new Error('Falha ao ler a imagem do PDF.'));
    reader.readAsDataURL(blob);
  });

const getImageDataUrl = (url: string): Promise<string | null> => {
  let cached = cachedImagePromises.get(url);
  if (!cached) {
    cached = fetch(url)
      .then((response) => {
        if (!response.ok) {
          return null;
        }
        return response.blob();
      })
      .then((blob) => {
        if (!blob) {
          return null;
        }
        return blobToDataUrl(blob);
      })
      .catch(() => null);
    cachedImagePromises.set(url, cached);
  }

  return cached;
};

export const getPdfBackgroundDataUrl = (): Promise<string | null> => getImageDataUrl(PDF_BACKGROUND_URL);

export const getPrefeituraLogoDataUrl = (): Promise<string | null> => getImageDataUrl(PREFEITURA_LOGO_URL);
